import { render, staticRenderFns } from "./EditAdoptPos.vue?vue&type=template&id=0f9781e7"
import script from "./EditAdoptPos.vue?vue&type=script&lang=js"
export * from "./EditAdoptPos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports